import { annotateTranscriptionError, createTranscriptionError } from './errors';

export async function transcribeAudio({ audio, language, mode, token, signal }) {
  const form = new FormData();
  form.append('audio', audio, 'chunk.mp3');
  const query = new URLSearchParams({ language, mode });
  let response;
  try {
    response = await fetch(`/api/transcriptions?${query}`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      body: form,
      signal,
    });
  } catch (error) {
    throw annotateTranscriptionError(error, { phase: 'api-upload' });
  }
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw createTranscriptionError(body.error || `Transcription failed (${response.status}).`, {
      code: `HTTP_${response.status}`,
      phase: 'api-response',
    });
  }
  if (!Array.isArray(body.chunks)) {
    throw createTranscriptionError('Invalid transcription response.', {
      code: 'INVALID_API_RESPONSE',
      phase: 'api-response',
    });
  }
  return body;
}
